'use strict';

import "@babel/polyfill";
// import 'rellax.min.js';
import { } from './view/_index';
import { parallax } from './view/_parallax';
import { form } from './view/_form';
//import { ua } from './view/_ua';
//import { header } from './view/_header';
